import { ROUTES } from "../Routes/routes";
import GenericLayout from "./GenericLayout";

export default function DeliverypartnerLayout() {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  const menu = [
    {
      key: ROUTES.DELIVERYPARTNER.DELIVERYPARTNER_DELIVERYPARTNERDASHBOARD
      , label: "Dashboard", icon: "bi-speedometer2"
      , iconImage: ''
    },
    {
      key: ROUTES.DELIVERYPARTNER.DELIVERYPARTNER_DeliveryPartnerReport
      , label: "Report",
      icon: "bi-file-earmark-text-fill", iconImage: ''
    },

  ];



  const menuGroups = [
    {
      title: "Master",
      icon: "bi-collection-fill",
      items: [
        {
          key: ROUTES.DELIVERYPARTNER.DeliverySchedule,
          label: "Office Timings",
          icon: "bi-clock-history",
          iconImage: ''
        },
      ]
    }
  ];


  return (
    <GenericLayout
      menu={menu}
      menuGroups={menuGroups}
      titleLabel="Milling Hub"
      profileRoute={ROUTES.MILLING.MILLING_PROFILE}
      showNotifications={true}
      apiNotificationUrl={`${API_BASE}/ClinicDetails/GetClinicNotifications`}
    />
  );
}
